import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Routers from '../../routes/Routes';
import { useOkta } from '../../hooks/oktaHook';

const MainComponent = () => {
  const { authState } = useOkta();

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        paddingLeft: 0,
        backgroundColor: '#F3F7FD',
        overflowX: 'auto',
        overflowY: 'auto',
        height: '100vh',
        marginLeft: authState?.isAuthenticated ? '56px' : '0px'
      }}>
      <Toolbar variant="dense" disableGutters sx={{ minHeight: 50, height: 50 }} />

      {/* All routing compoent  */}
      <Routers />
    </Box>
  );
};

export default MainComponent;
